<template>
  <div class="tab-container">
    <div class="tab-section">
      <div class="title">Modifier les informations de la campagne</div>
      <div class="input-inline">
        <VField
          label="Nom de la campagne"
          helper="Vous pouvez mettre à jour le nom de votre campagne ici"
          name="name"
          :class="{ invalid: campaignNameIsInvalid !== null }"
          :modelValue="data.name"
          @input="(event) => emits('changeName', event)"
        />
        <div class="input-wrapper">
          <label for="space">Espace de la campagne</label>
          <v-select
            id="space"
            name="space"
            label="name"
            :modelValue="data.workspace_id"
            :reduce="(space) => space.workspace_id"
            :clearable="false"
            :options="spaces"
            :disabled="true"
          >
            <template v-slot:no-options="{ search, searching }">
              <div style="padding: 8px 0">
                Pas de résultat {{ searching ? ` pour ${search}` : "" }}.
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <p
        v-if="campaignNameIsInvalid"
        class="red-color bold"
        style="margin-top: 16px"
        v-text="
          getError(campaignNameIsInvalid.name, campaignNameIsInvalid.params)
        "
      />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { inject, computed } from "vue";
import { useCampaignStore } from "@/stores/campaign.js";
import { useSpaceStore } from "@/stores/space.js";
import { getDate } from "@/composables/utils.js";
import { getError } from "@/composables/error.js";
import { useToast } from "vue-toastification";

const route = useRoute();

const toast = useToast();

const emitter = inject("emitter");

const emits = defineEmits(["changeName", "changeInvitation", "toggleError"]);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const { spaces } = useSpaceStore();

const campaignStore = useCampaignStore();

const campaignNameIsInvalid = computed(() => {
  if (!props.data.name) {
    emits("toggleError", {
      name: "ERROR_REQUIRED_FIELD",
    });
    return { name: "ERROR_REQUIRED_FIELD" };
  }

  if (props.data.name.length > 50) {
    emits("toggleError", {
      name: "ERROR_TOO_LONG",
      params: { size: 50 },
    });
    return { name: "ERROR_TOO_LONG", params: { size: 50 } };
  }

  emits("toggleError", null);
  return null;
});

const calibrationIsUpdated = computed(() => {
  const campaignObj = campaignStore.campaigns.find(
    (elt) => elt.campaign_id === props.data.campaign_id
  );

  if (!campaignObj) return null;

  return campaignObj.calibrationIsUpdated;
});

const currentCalibration = computed(() => {
  const campaignObj = campaignStore.campaigns.find(
    (elt) => elt.campaign_id === props.data.campaign_id
  );

  if (!campaignObj) return null;
  return campaignStore.campaignsCalibrations.find(
    (elt) => elt.calibration_id === campaignObj.calibration_id
  );
});

async function updateCalibration() {
  const { calibration } = await campaignStore.updateCalibration(
    props.data.company_id,
    props.data.workspace_id,
    props.data.campaign_id
  );

  let toastObj;

  if (calibration) {
    toastObj = {
      message: "La dernière calibration a bien été récupérée",
      type: "success",
    };

    if (route.name === "campaign") emitter.emit("updateCalibration");
  } else {
    toastObj = {
      message:
        "Une erreur s'est produite lors de la récupération de la dernière calibration",
      type: "error",
    };
  }

  toast(toastObj.message, {
    type: toastObj.type,
  });
}
</script>
